import { env } from '@/config/env';

/**
 * Удаление аккаунта. Необратимо: сервер каскадно стирает профиль,
 * генерации, кредиты, историю, избранное, реферальные связи и файлы —
 * см. supabase/functions/delete-account.
 */
export class DeleteAccountError extends Error {
  readonly code: string;

  constructor(message: string, code: string) {
    super(message);
    this.name = 'DeleteAccountError';
    this.code = code;
  }
}

interface ServerError {
  error?: { code?: string; message?: string };
}

export async function deleteAccount(accessToken: string): Promise<void> {
  let response: Response;

  try {
    response = await fetch(`${env.VITE_SUPABASE_URL}/functions/v1/delete-account`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        apikey: env.VITE_SUPABASE_ANON_KEY,
        'Content-Type': 'application/json',
      },
    });
  } catch {
    throw new DeleteAccountError('Нет связи с сервером. Проверьте интернет.', 'NETWORK_ERROR');
  }

  const payload = (await response.json().catch(() => null)) as ({ deleted: boolean } & ServerError) | null;

  if (!payload) {
    throw new DeleteAccountError('Сервер ответил неожиданно.', 'UNKNOWN_ERROR');
  }

  if (!response.ok || payload.error) {
    throw new DeleteAccountError(
      payload.error?.message ?? 'Не удалось удалить аккаунт.',
      payload.error?.code ?? 'UNKNOWN_ERROR',
    );
  }
}
